
import { client } from "helpers/client"
import qs from "qs"


// --------------------------------------------------------------- Apps Wishlist -------------------------------------------------------------------- //

export const get_All_app_wishList = params => {
    return client('/WishList/Application/GetAll', {params,paramsSerializer: params => qs.stringify(params)})
}

export const create_app_wishList = async wishList => {
    return client('/WishList/Application/Create', { data: wishList })
   
}

export const delete_app_wishList = async id => {
   return client('/WishList/Application/Delete', { params: { applicationId:id }, method: 'POST' })
}


// --------------------------------------------------------------- Addons Wishlist -------------------------------------------------------------------- //

export const get_All_Addons_wishList = params => {
    return client('/WishList/AddOn/GetAll', {params,paramsSerializer: params => qs.stringify(params)})
}

export const create_Addons_wishList = async wishList => {
    return client('/WishList/AddOn/Create', { data: wishList })
   
}

export const delete_Addons_wishList = async id => {
   return client('/WishList/AddOn/Delete', { params: { addonId:id }, method: 'POST' })
}
